import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Header } from './Header';
import { HeroSystem } from './HeroSystem';
import { OfferLearning } from './OfferLearning';
import { RecipesAccess } from './RecipesAccess';
import { TrustFooter } from './TrustFooter';
export function LandingPage() {
  useScreenInit();
  return <div className="min-h-screen w-full overflow-hidden bg-[#fcfbf7] text-[#344833]" data-id="element-164" data-mp="ulmupaxswnm7">
      <Header data-id="element-165" data-mp="pod6tzq28k0h" />
      <main data-id="element-166" data-mp="powemnlzxs0s">
        <HeroSystem data-id="element-167" data-mp="pomo8yx1hiuk" />
        <OfferLearning data-id="element-168" data-mp="pp4pyb2h0p9v" />
        <RecipesAccess data-id="element-169" data-mp="kw393xipefnn" />
        <TrustFooter data-id="element-170" data-mp="kvtic7pu44gw" />
      </main>
    </div>;
}